package com.example.readingnotes.domain.usecase

import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.util.Result

class GetSearchSuggestionsUseCase(
    private val postRepository: PostRepository,
) {
    suspend operator fun invoke(
        query: String,
        limit: Int = 5,
    ): Result<List<String>> =
        if (query.isBlank() || query.length < 2) {
            Result.success(emptyList())
        } else {
            postRepository.getSearchSuggestions(query, limit)
        }
}
